var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('Upload',{ref:"nius",attrs:{"multiple":"","type":"drag","on-success":_vm.success,"on-remove":_vm.remove,"action":"/api/upload/upload"}},[_c('div',{staticStyle:{"padding":"20px 0"}},[_c('Icon',{staticStyle:{"color":"#3399ff"},attrs:{"type":"ios-cloud-upload","size":"52"}}),_vm._v(" "),_c('p',[_vm._v("批量上传文件，或将文件拖入到此处")])],1)])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-e4509b8e","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/public/upload/UploadBuch.vue
// module id = null
// module chunks = 